<template>
  <div class="row mt-3" v-if="pagination.last_page > 1">
    <div class="col-sm-5">
      <div class="datatable_info" role="status" aria-live="polite">
        Записи с {{pagination.from}} до {{pagination.to}} из {{pagination.total}} записей
      </div>
    </div>
    <div class="col-sm-7">
      <nav class="float-right">
        <ul class="pagination">
          <li
            class="page-item"
            v-if="pagination.last_page > 5"
            :class="{'disabled': (pagination.current_page <= 1) }">
            <button
              class="page-link"
              @click.prevent="changePage(1)"
              :class="{'disabled':pagination.current_page <= 1}"
              :disabled="pagination.current_page <= 1"
              aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
            <li class="page-item" :class="{'disabled': (pagination.current_page <= 1) }">
              <button
                class="page-link"
                @click.prevent="changePage(pagination.current_page - 1)"
                :disabled="pagination.current_page <= 1"
                tabindex="-1">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
              </button>
            </li>
            <li
              v-for="(page, index) in pages"
              class="page-item"
              :class="isCurrentPage(page) ? 'active' : ''"
              :key="index">
              <button class="page-link" @click.prevent="changePage(page)">{{ page }}</button>
            </li>
            <li class="page-item" :class="{'disabled': (pagination.current_page >= pagination.last_page) }">
              <button
                class="page-link"
                @click.prevent="changePage(pagination.current_page + 1)"
                :disabled="pagination.current_page >= pagination.last_page">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </button>
            </li>
          <li
            class="page-item"
            :class="{'disabled': (pagination.current_page >= pagination.last_page) }"
            v-if="pagination.last_page > 5">
            <button
              class="page-link"
              @click.prevent="changePage(pagination.last_page)"
              :disabled="pagination.current_page >= pagination.last_page"
              aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: ['pagination', 'offset'],
  methods: {
    isCurrentPage(page) {
      return this.pagination.current_page === page;
    },
    changePage(page) {
      if (page > this.pagination.last_page) {
        page = this.pagination.last_page;
      }
      this.pagination.current_page = page;
      this.$emit('paginate');
    },
  },
  computed: {
    pages() {
      const pages = [];
      let from = this.pagination.current_page - Math.floor(this.offset / 2);
      if (from < 1) {
        from = 1;
      }
      let to = from + this.offset - 1;
      if (to > this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      while (from <= to) {
        pages.push(from);
        from += 1;
      }

      return pages;
    },
  },
};
</script>
